/* src/app/adhoc-report/new-report-modal/new-report-modal.component.scss */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-control {
  color: black !important;
  padding: 3px !important;
}
textarea.form-control {
  min-height: 200px;
  font-family: monospace;
}
/*# sourceMappingURL=new-report-modal.component.css.map */
